export const filterConfig = [
  {
    id: 'NumeroNF',
    type: 'text',
    label: 'Número NF',
    placeholder: 'Digite o número da NF'
  },
  {
    id: 'NumeroPedidoTMS',
    type: 'text',
    label: 'Número Pedido Embarcador',
    placeholder: 'Digite o número do pedido'
  },
  {
    id: 'CNPJCliente',
    type: 'text',
    label: 'CNPJ Cliente',
    placeholder: 'Digite o CNPJ do cliente'
  },
  {
    id: 'NomeCliente',
    type: 'text',
    label: 'Nome Cliente',
    placeholder: 'Digite o nome do cliente'
  },
  {
    id: 'TipoCobranca',
    type: 'select',
    label: 'Tipo Cobrança',
    placeholder: 'Selecione...',
    options: [
      { value: 'Paletização', label: 'Paletização' },
      { value: 'Etiquetagem', label: 'Etiquetagem' },
      { value: 'Armazenagem', label: 'Armazenagem' },
      { value: 'Avulsa', label: 'Avulsa' }
    ]
  },
  {
    id: 'DataEmissaoInicio',
    type: 'date',
    label: 'Data Emissão (Início)'
  },
  {
    id: 'DataEmissaoFim',
    type: 'date',
    label: 'Data Emissão (Fim)'
  },
  {
    id: 'UsuarioEmissao',
    type: 'text',
    label: 'Usuário Emissão',
    placeholder: 'Digite o usuário de emissão'
  }
];
